const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactOutreachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 500.0004,
    y1: 748.5149,
    x2: 500.0004,
    y2: 251.4859,
    gradientTransform: "matrix(0.025,0,0,0.025,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,49.803922%,83.137255%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(36.470588%,63.529412%,92.941176%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 16.679688 12.09375 C 16.679688 12.09375 17.066406 9.808594 16.386719 8.605469 C 15.707031 7.398438 14.335938 6.289062 12.503906 6.289062 C 10.671875 6.289062 9.296875 7.398438 8.613281 8.605469 C 7.933594 9.808594 8.320312 12.09375 8.320312 12.09375 C 7.941406 12.070312 7.578125 12.546875 7.648438 13.402344 C 7.71875 14.261719 8.066406 14.375 8.402344 14.515625 C 8.738281 14.652344 8.171875 15.441406 9.609375 17.101562 C 11.042969 18.757812 12.5 18.710938 12.5 18.710938 C 12.5 18.710938 13.957031 18.757812 15.390625 17.101562 C 16.828125 15.441406 16.261719 14.652344 16.597656 14.515625 C 16.933594 14.375 17.28125 14.261719 17.351562 13.402344 C 17.421875 12.546875 17.0625 12.070312 16.679688 12.09375 Z M 16.679688 12.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,90.980392%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.824219 9.671875 C 3.480469 9.671875 3.203125 9.390625 3.203125 9.046875 L 3.203125 3.824219 C 3.203125 3.480469 3.484375 3.203125 3.824219 3.203125 L 9.042969 3.203125 C 9.390625 3.203125 9.667969 3.484375 9.667969 3.824219 C 9.667969 4.167969 9.386719 4.449219 9.042969 4.449219 L 4.449219 4.449219 L 4.449219 9.042969 C 4.449219 9.390625 4.167969 9.671875 3.824219 9.671875 Z M 3.824219 9.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,90.980392%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 21.175781 9.671875 C 20.832031 9.671875 20.550781 9.390625 20.550781 9.046875 L 20.550781 4.449219 L 15.953125 4.449219 C 15.605469 4.449219 15.332031 4.167969 15.332031 3.824219 C 15.332031 3.480469 15.609375 3.203125 15.953125 3.203125 L 21.175781 3.203125 C 21.519531 3.203125 21.796875 3.484375 21.796875 3.824219 L 21.796875 9.042969 C 21.796875 9.390625 21.515625 9.671875 21.175781 9.671875 Z M 21.175781 9.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,90.980392%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 21.175781 21.796875 L 15.953125 21.796875 C 15.605469 21.796875 15.332031 21.515625 15.332031 21.175781 C 15.332031 20.832031 15.609375 20.550781 15.953125 20.550781 L 20.550781 20.550781 L 20.550781 15.953125 C 20.550781 15.609375 20.832031 15.328125 21.171875 15.328125 C 21.515625 15.328125 21.796875 15.609375 21.796875 15.953125 L 21.796875 21.175781 C 21.796875 21.515625 21.515625 21.796875 21.175781 21.796875 Z M 21.175781 21.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509804%,90.980392%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 9.046875 21.796875 L 3.824219 21.796875 C 3.480469 21.796875 3.203125 21.515625 3.203125 21.175781 L 3.203125 15.953125 C 3.203125 15.609375 3.484375 15.328125 3.824219 15.328125 C 4.167969 15.328125 4.449219 15.609375 4.449219 15.953125 L 4.449219 20.550781 L 9.042969 20.550781 C 9.390625 20.550781 9.667969 20.832031 9.667969 21.171875 C 9.667969 21.515625 9.390625 21.796875 9.046875 21.796875 Z M 9.046875 21.796875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactOutreachIcon);
export default __webpack_public_path__ + "static/media/contactOutreachIcon.b892b76d7ab993b8364c0e78d9efbaba.svg";
export { ForwardRef as ReactComponent };